<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="data.form"
                    :validations="validations.prioridadeId"
                    label="Prioridade"
                    show-default-option
                    text-field="nome"
                    v-model="model.prioridadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col  cols="3">
                <rkm-form-input
                    :validations="validations.tempoDeAtendimento"
                    @blur="handleBlur"
                    @focus="handleFocus"
                    @input="handleHoraInput"
                    @keypress="event => /^[0-9]$/.test(event.key) || event.preventDefault()"
                    label="Tempo de atendimento"
                    placeholder="HH:MM"
                    v-model="model.tempoDeAtendimento"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Mixins.
import { repository, error, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {

            return {
                prioridadeId: { required: true },
                tempoDeAtendimento: { required: true, max: 6 },
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('manutencao.parametrizacao')
        }

        if (this.sla) {

            this.loadSla()
        }
    },
    data: () => ({
        model: {
            id: null,
            prioridadeId: null,
            sla: null,
            tempoDeAtendimento: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        loadSla() {

            Object.assign(this.model, this.sla)

        },
        handleFocus() {


            if (this.model.tempoDeAtendimento === null || this.model.tempoDeAtendimento === '') {

                    this.model.tempoDeAtendimento = '00:00'
            }
        },
        handleBlur() {

            if (this.model.tempoDeAtendimento === '00:00') {

                this.model.tempoDeAtendimento = null
            }
        },
        handleHoraInput() {

            let value = this.model.tempoDeAtendimento.replace(':', '');
            value = value.replace(/^0+/, '');

            while (value.length < 4) {

                value = '0' + value;
            }

            if (value.length > 4) {

                this.model.tempoDeAtendimento = value.slice(0, 3) + ':' + value.slice(3, 5);
            } else {

                this.model.tempoDeAtendimento = value.slice(0, 2) + ':' + value.slice(2, 4);
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (!this.sla && this.prioridadeJaAdicionada()) {

                        this.showValidationNotification('A prioridade já foi incluída.')

                        return
                    }

                    if (this.sla) {

                        Object.assign(this.originalSla, this.prepareData())
                    }
                    else {

                        this.data.model.sla.push(this.prepareData())
                    }

                    this.$emit('save')
                })
        },
        prioridadeJaAdicionada() {

            return !!this.data.model.sla.find(s => s.prioridadeId === this.model.prioridadeId)
        },
        prepareData() {

            const data = this.clone(this.model)

            data.prioridadeNome = this.data.form.find(t => t.id === data.prioridadeId).nome

            return data
        }
    },
    mixins: [repository, error, object],
    props: {
        data: { type: Object, required: true },
        originalSla: { type: Object },
        sla: { type: Object },
    },
}
</script>